
import {remove as removeDiacritics} from 'diacritics';

import {
    REQUEST_GET_ODRUDA_LIST,
    RESPONSE_GET_ODRUDA_LIST,
    SET_FILTER
} from '../actions/OdrudaList';

const initialState = {
    data: {},
    filter: {},
    loading: false,
    initialized: false
};

function correspondFilterAttr(item, filter, attrName) {
    let correspond = true;
    if (filter[attrName]) {
        correspond = item.attrs.reduce((previous, current) => {
            return (current.atribut_nazev === attrName)
                ? (current.atribut_hodnota === filter[attrName]) || previous
                : previous;
        }, false);
    }
    return correspond;
}

function compareTextWithFilter(text, filterValue) {
    return (removeDiacritics(text).indexOf(removeDiacritics(filterValue)) !== -1);
}

function correspondFilterName(item, filter) {
    let nazev = item.nazev.toLowerCase();
    let nazevLidovy = item.nazev_lidovy.toLowerCase();
    let synonyma = item.synonyma.toLowerCase();
    let correspond = true;
    if (filter.name) {
        let filterValue = filter.name.toLowerCase();
        correspond =
            (compareTextWithFilter(nazev, filterValue)) ||
            (compareTextWithFilter(synonyma, filterValue)) ||
            (compareTextWithFilter(nazevLidovy, filterValue));
    }
    return correspond;
}

export function getFilteredOdrudaList(state) {
    let items = [];
    if (state.data.items) {
        items = state.data.items.filter(item => {
            let correspond = true;
            correspond = correspond && correspondFilterName(item, state.filter);
            correspond = correspond && correspondFilterAttr(item, state.filter, 'typ_odrudy');
            correspond = correspond && correspondFilterAttr(item, state.filter, 'bobule_barva');
            correspond = correspond && correspondFilterAttr(item, state.filter, 'bobule_velikost');
            correspond = correspond && correspondFilterAttr(item, state.filter, 'hrozen_velikost');
            correspond = correspond && correspondFilterAttr(item, state.filter, 'doba_zrani');
            correspond = correspond && correspondFilterAttr(item, state.filter, 'status_odrudy');
            return correspond;
        });
    }
    return items;
}

export default function odrudaList(state = initialState, action) {
    switch (action.type) {
        case REQUEST_GET_ODRUDA_LIST:
            return {
                ...state,
                data: {},
                loading: true
            };

        case RESPONSE_GET_ODRUDA_LIST:
            return {
                ...state,
                initialized: true,
                data: action.data,
                filter: {},
                loading: false
            };

        case SET_FILTER:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    [action.attributeId]: action.attributeValue
                }
            }

        default:
            return state
    }
}
